const TEST_ID_PREFIX = 'app-error';

export default TEST_ID_PREFIX;
